const BlogImageSection = ({ article }) => {
	// Render
	return (
		<figure className='overflow-hidden rounded-media border bg-surface'>
			<img className='aspect-video w-full object-cover' src={article.cover} alt={`${article.title} cover`} />
		</figure>
	);
};

export { BlogImageSection };
